
document.addEventListener('DOMContentLoaded', function() {
    var swiperContainer = document.querySelector('.collection-list-swiper-container');
    if (swiperContainer) {
        var columnsDesktop = parseInt(swiperContainer.getAttribute('data-columns-desktop'), 10);

        var swiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: '.collection-slider-next',
                prevEl: '.collection-slider-prev',
            },
            pagination: {
                el: '.slider-counter', // Use this class for pagination
                type: 'custom',
                renderCustom: function (swiper, current, total) {
                    return `
                        <span class="slider-counter--current">${current}</span>
                        <span aria-hidden="true"> / </span>
                        <span class="slider-counter--total">${total}</span>
                    `;
                },
            },
            loop: false,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: columnsDesktop,
                }
            }
        });

        // Optional: Update counter on slide change
        swiper.on('slideChange', function () {
            document.querySelector('.slider-counter--current').textContent = swiper.realIndex + 1;
        });

        // Ensure the total slide count is updated initially
        document.querySelector('.slider-counter--total').textContent = swiper.slides.length;
    }
});

